export default [
  {
    accountNumber: 3160,
    name: 'Leistungen nach § 13b UStG mit Vorsteuerabzug',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 3165,
    name: 'Leistungen nach § 13b UStG ohne Vorsteuerabzug',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4200,
    name: 'Raumkosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4212,
    name: 'Miete/Aufwendungen für doppelte',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4220,
    name: 'Pacht (unbewegliche Wirtschaftsgüter)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4228,
    name: 'Miet- und Pachtnebenkosten, die gewerbesteuerlich nicht hinzuzurechnen sind',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4230,
    name: 'Heizung',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4240,
    name: 'Gas, Strom, Wasser',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4280,
    name: 'Sonstige Raumkosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4290,
    name: 'Grundstücksaufwendungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4961,
    name: 'Pacht (bewegliche Wirtschaftsgüter)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4991,
    name: 'Kalkulatorische Miete und Pacht',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4970,
    name: 'Nebenkosten des Geldverkehrs',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4971,
    name: 'Verwahrentgelt',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4990,
    name: 'Kalkulatorischer Unternehmerlohn',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4992,
    name: 'Kalkulatorische Zinsen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4994,
    name: 'Kalkulatorische Wagnisse',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4995,
    name: 'Kalkulatorischer Lohn für unentgeltliche Mitarbeiter',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4996,
    name: 'Herstellungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4997,
    name: 'Verwaltungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4998,
    name: 'Vertriebskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4211,
    name: 'Aufwendungen für gemietete oder gepachtete unbewegliche Wirtschaftsgüter, die gewerbesteuerlich hinzuzurechnen sind',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4215,
    name: 'Leasing (unbewegliche Wirtschaftsgüter)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4808,
    name: 'Zuführung zu Aufwandsrückstellungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4810,
    name: 'Mietleasing bewegliche Wirtschaftsgüter für technische Anlagen und Maschinen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4815,
    name: 'Kaufleasing',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4960,
    name: 'Mieten für Einrichtungen (bewegliche Wirtschaftsgüter)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4963,
    name: 'Aufwendungen für gemietete oder gepachtete bewegliche Wirtschaftsgüter, die gewerbesteuerlich hinzuzurechnen sind',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4965,
    name: 'Mietleasing bewegliche Wirtschaftsgüter für Betriebs- und Geschäftsausstattung',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 3600,
    name: 'Nicht abziehbare Vorsteuer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 3610,
    name: 'Nicht abziehbare Vorsteuer 7 %',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 3660,
    name: 'Nicht abziehbare Vorsteuer 19 %',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4149,
    name: 'Pauschale Steuer auf sonstige Bezüge z.B. Fahrtkostenzuschüsse',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4167,
    name: 'Pauschale Steuer auf sonstige Bezüge (z.B. Direktversicherungen)',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4194,
    name: 'Pauschale Steuer für Minijobber',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4198,
    name: 'Pauschale Steuer für Arbeitnehmer',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4199,
    name: 'Pauschale Steuer für Aushilfen',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4210,
    name: 'Sonstige Steuern',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4300,
    name: 'Nicht abziehbare Vorsteuer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4301,
    name: 'Nicht abziehbare Vorsteuer 7 %',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4306,
    name: 'Nicht abziehbare Vorsteuer 19 %',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4320,
    name: 'Gewerbesteuer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4340,
    name: 'Sonstige Betriebssteuern',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4350,
    name: 'Verbrauchsteuer (sonstige Steuern)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4355,
    name: 'Ökosteuer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4396,
    name: 'Steuerlich abzugsfähige Verspätungszuschläge',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4397,
    name: 'Steuerlich nicht abzugsfähige Verspätungszuschläge und Zwangsgelder',
    group: 'Nicht abzugsfähige Betriebsausgaben',
  },
  {
    accountNumber: 4660,
    name: 'Reisekosten Arbeitnehmer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4663,
    name: 'Reisekosten Arbeitnehmer Fahrtkosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4664,
    name: 'Reisekosten Arbeitnehmer Verpflegungsmehraufwand',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4666,
    name: 'Reisekosten Arbeitnehmer Übernachtungsaufwand',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4668,
    name: 'Kilometergelderstattung Arbeitnehmer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4670,
    name: 'Reisekosten Unternehmer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4672,
    name: 'Reisekosten Unternehmer (nicht abziehbarer Anteil)',
    group: 'Nicht abziehbare Betriebsausgaben',
  },
  {
    accountNumber: 4673,
    name: 'Reisekosten Unternehmer',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4674,
    name: 'Reisekosten Unternehmer Verpflegungsmehraufwand',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4676,
    name: 'Reisekosten Unternehmer Übernachtungsaufwand und Reisene-benkosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4678,
    name: 'Fahrten zwischen Wohnung und',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4680,
    name: 'Fahrten zwischen Wohnung und',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4681,
    name: 'Verpflegungsmehraufwendungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4146,
    name: 'Freiwillige Zuwendungen an Minijobber',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4147,
    name: 'Freiwillige Zuwendungen an Gesellschafter-Geschäftsführer',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4151,
    name: 'Sachzuwendungen und Dienstleistungen an Minijobber',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4152,
    name: 'Sachzuwendungen und Dienstleistungen an Arbeitnehmer',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4153,
    name: 'Sachzuwendungen und Dienstleistungen an Gesellschafter-Geschäftsführer',
    group: 'Personalaufwand',
  },
  {
    accountNumber: 4630,
    name: 'Geschenke abzugsfähig ohne § 37b',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4631,
    name: 'Geschenke abzugsfähig mit § 37b',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4632,
    name: 'Pauschale Steuer für Geschenke und Sachzuwendungen und Zuwendungen abzugsfähig',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4635,
    name: 'Geschenke nicht abzugsfähig ohne § 37b EStG',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4636,
    name: 'Geschenke nicht abzugsfähig mit § 37b EStG',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4637,
    name: 'Pauschale Steuer für Geschenke und Zuwendungen nicht abzugsfähig',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4638,
    name: 'Geschenke ausschließlich betrieblich genutzt',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4640,
    name: 'Repräsentationskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4650,
    name: 'Bewirtungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4554,
    name: 'Nicht abzugsfähige Bewirtungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4653,
    name: 'Aufmerksamkeiten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4655,
    name: 'Nicht abzugsfähige Betriebsausgaben aus Werbe- und Repräsentationskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4910,
    name: 'Porto',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4822,
    name: 'Abschreibungen auf immaterielle',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4823,
    name: 'Abschreibungen auf selbst geschaffene immaterielle Vermögensgegenstände',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4824,
    name: 'Abschreibungen auf den Geschäfts- oder Firmenwert',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4825,
    name: 'Außerplanmäßige Abschreibungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4826,
    name: 'Außerplanmäßige Abschreibungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4827,
    name: 'Außerplanmäßige Abschreibungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4830,
    name: 'Abschreibungen auf Sachanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4831,
    name: 'Abschreibungen auf Gebäude',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4832,
    name: 'Abschreibungen auf Fahrzeuge',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4833,
    name: 'Abschreibungen auf Gebäudeanteil',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4840,
    name: 'Außerplanmäßige Abschreibungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4841,
    name: 'Absetzung für außergewöhnliche technische und wirtschaftliche Abnutzung der Gebäude',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4842,
    name: 'Absetzung für außergewöhnliche technische und wirtschaftliche Abnutzung der Fahrzeuge',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4843,
    name: 'Absetzung für außergewöhnliche technische und wirtschaftliche Abnutzung sonstiger Wirtschaftsgüter',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4850,
    name: 'Abschreibungen auf Sachanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4851,
    name: 'Sonderabschreibungen nach § 7g Abs. 5 EStG (ohne Fahrzeuge)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4852,
    name: 'Sonderabschreibungen nach § 7g Abs. 5 EStG (für Fahrzeuge)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4853,
    name: 'Kürzung der Anschaffungs- oder Herstellungskosten nach § 7g Abs. 2 EStG (ohne Fahrzeuge)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4854,
    name: 'Kürzung der Anschaffungs- oder Herstellungskosten nach § 7g Abs. 2 EStG (für Fahrzeuge)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4855,
    name: 'Sofortabschreibung geringwertiger Wirtschaftsgüter',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4856,
    name: 'Sonderabschreibungen nach § 7b EStG (Mietwohnungsneubau)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4859,
    name: 'Abzugsbetrag nach § 6b EStG',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4860,
    name: 'Abschreibungen auf aktivierte, geringwertige Wirtschaftsgüter',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4862,
    name: 'Abschreibungen auf den Sammelposten Wirtschaftsgüter',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4865,
    name: 'Außerplanmäßige Abschreibungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4866,
    name: 'Abschreibungen auf Finanzanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4870,
    name: 'Abschreibungen auf Finanzanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4871,
    name: 'Abschreibungen auf Finanzanlagen § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG (dauerhaft)',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4873,
    name: 'Abschreibungen auf Finanzanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4874,
    name: 'Abschreibungen auf Finanzanlagen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4875,
    name: 'Abschreibungen auf Wertpapiere',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4876,
    name: 'Abschreibungen auf Wertpapiere des Umlaufvermögens § 3 Nr. 40 EStG bzw. § 8b Abs. 3 KStG',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4877,
    name: 'Abschreibung',
  },
  {
    accountNumber: 4260,
    name: 'Instandhaltung betrieblicher Räume',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4800,
    name: 'Reparaturen und Instandhaltungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4801,
    name: 'Reparaturen und Instandhaltung',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4805,
    name: 'Reparaturen und Instandhaltungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4806,
    name: 'Wartungskosten für Hard- und Software',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4809,
    name: 'Sonstige Reparaturen und Instandhaltungen',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4950,
    name: 'Rechts- und Beratungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4955,
    name: 'Buchführungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4957,
    name: 'Abschluss- und Prüfungskosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4138,
    name: 'Beiträge zur Berufsgenossenschaft',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4380,
    name: 'Beiträge',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4920,
    name: 'Telefon',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4925,
    name: 'Internetkosten',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4930,
    name: 'Bürobedarf',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4980,
    name: 'Sonstiger Betriebsbedarf',
    group: 'Sonstige betriebliche Aufwendungen',
  },
  {
    accountNumber: 4985,
    name: 'Werkzeuge und Kleingeräte HB',
    group: 'Sonstige betriebliche Aufwendungen',
  },
];
